/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyTemperatureSensorSerializer
 */
export interface ReadOnlyTemperatureSensorSerializer {
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyTemperatureSensorSerializer
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyTemperatureSensorSerializer
     */
    serialNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyTemperatureSensorSerializer
     */
    sensorName: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyTemperatureSensorSerializer
     */
    sensorType?: ReadOnlyTemperatureSensorSerializerSensorTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyTemperatureSensorSerializer
     */
    sensorZone?: number;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyTemperatureSensorSerializer
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyTemperatureSensorSerializer
     */
    readonly updatedAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyTemperatureSensorSerializer
     */
    monitoredObject: number;
}

export function ReadOnlyTemperatureSensorSerializerFromJSON(json: any): ReadOnlyTemperatureSensorSerializer {
    return ReadOnlyTemperatureSensorSerializerFromJSONTyped(json, false);
}

export function ReadOnlyTemperatureSensorSerializerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyTemperatureSensorSerializer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'serialNumber': json['serial_number'],
        'sensorName': json['sensor_name'],
        'sensorType': !exists(json, 'sensor_type') ? undefined : json['sensor_type'],
        'sensorZone': !exists(json, 'sensor_zone') ? undefined : json['sensor_zone'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'updatedAt': !exists(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
        'monitoredObject': json['monitored_object'],
    };
}

export function ReadOnlyTemperatureSensorSerializerToJSON(value?: ReadOnlyTemperatureSensorSerializer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'serial_number': value.serialNumber,
        'sensor_name': value.sensorName,
        'sensor_type': value.sensorType,
        'sensor_zone': value.sensorZone,
        'monitored_object': value.monitoredObject,
    };
}

/**
* @export
* @enum {string}
*/
export enum ReadOnlyTemperatureSensorSerializerSensorTypeEnum {
    TemperatureSensor = 'temperature_sensor'
}


